<template>
  <v-card v-if="totalPrice" class="text-md-start text-center pa-6">
    <v-card-title
      class="body-heading-medium d-flex justify-md-start justify-center"
      >Order Summary
    </v-card-title>
    <v-card-text>
      <v-list-item v-for="item in items" :key="item.content" class="px-0">
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters>
              <v-col cols="12" md="6">{{ item.title }}</v-col>
              <v-col cols="12" md="6">{{ item.content }}</v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-expansion-panels accordion flat tile>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Have a promo code?
          </v-expansion-panel-header>
          <v-expansion-panel-content style="padding: 0">
            <div class="d-flex align-center">
              <v-text-field
                :loading="isApplyingPromo"
                class="mr-4"
                v-model="promoCode"
                :error="isApplyingPromoError"
                :error-messages="
                  isApplyingPromoError ? [`${redeemErrorMsg.message}`] : null
                "
              ></v-text-field>
              <v-btn v-on:click="applyPromoCode(promoCode)">Apply</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-list-item class="px-0" v-if="discountAmount">
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters>
              <v-col cols="12" md="6">Discount:</v-col>
              <v-col cols="12" md="6"> {{ `$${discountAmount} off` }}</v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="px-0">
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters>
              <v-col cols="12" md="6">Total:</v-col>
              <v-col cols="12" md="6" class="body-heading-medium"
                >{{ `$${totalPrice}` }}
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OrderSummaryCard',
  props: {
    pointsAmount: {
      required: true
    },
    price: {
      required: true
    },
    tax: {
      required: true
    },
    totalPrice: {
      required: true
    },
    checkPromoCode: {
      required: true
    },
    discountAmount: {
      required: false
    }
  },

  data() {
    return {
      promoCode: '',
      applyPromoCodeStatus: null,
      redeemErrorMsg: null,
      items: [
        {
          title: 'Points Amount:',
          content: this.pointsAmount
        },
        {
          title: 'Price:',
          content: `$${this.price}`
        },
        {
          title: 'Estimated Tax:',
          content: `$${this.tax}`
        }
      ]
    };
  },
  methods: {
    applyPromoCode(code) {
      this.applyPromoCodeStatus = 'pending';
      this.checkPromoCode(code)
        .then(() => (this.applyPromoCodeStatus = 'success'))
        .catch(err => {
          this.redeemErrorMsg = err;
          this.applyPromoCodeStatus = 'error';
        });
    }
  },
  computed: {
    isApplyingPromo() {
      return (
        this.applyPromoCodeStatus && this.applyPromoCodeStatus === 'pending'
      );
    },
    isApplyingPromoError() {
      return this.applyPromoCodeStatus
        ? this.applyPromoCodeStatus === 'error'
        : false;
    }
  }
};
</script>

<style scoped>
.v-expansion-panel-header {
  padding: 0;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Points/Purchase/OrderSummaryCard.vue